export default {
  error: 'Fehler',
  warning: 'Warnung',
  'error.errorNum': 'Fehler: {number}',
  'error.notFound': '{entity} nicht gefunden',
  'error.page403': 'Sie sind nicht berechtigt, auf diese Seite zuzugreifen',
  'error.page404': 'Die aufgerufene Seite existiert nicht',
  'error.page500': 'Etwas ist schiefgelaufen',
  'error.pageWarning': 'Es gibt Probleme mit Ihrer Aktion',
  'error.noPermissions': 'Keine ausreichenden Berechtigungen',
  'error.userExist': 'Der Benutzer existiert bereits',
  'error.userAssigned': 'Der Benutzer ist bereits dem Unternehmen zugewiesen',
  'error.noEmail': 'E-Mail-Adresse ist erforderlich',
  'error.validEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'error.noConnection': 'Keine Internetverbindung',
  'error.na': 'Keine',
  'error.fileSize': 'Dateigröße überschreitet das Limit von {size}MB',
  'error.uploadRestriction':
    'Es dürfen nur {extensions}-Dateien hochgeladen werden',
  'error.reCAPTCHA.loaded': 'reCAPTCHA nicht geladen',
  'error.load.script': 'Skript konnte nicht geladen werden',
};
